import api from './HttpService';
import { ROLES, PERMISSIONS } from '../configs/ApiActionUrl';

async function getAll(pageOption, sortData, keyword) {
  let query = '';

  if (pageOption) {
    const { page, pageSize } = pageOption;
    if (page !== undefined && pageSize !== undefined) {
      query = `?page=${page + 1}&limit=${pageSize}`;
    }
  }

  if (sortData) {
    const { sortField, sort } = sortData;
    if (sortField && sort) {
      query += `&sort_by=${sortField}&order_by=${sort}`;
    }
  }

  if (keyword) {
    query += `&search=${keyword}`;
  }

  try {
    const res = await api.get(ROLES.LIST + query);
    return res;
  } catch (error) {
    // Handle errors here
    return error; // Rethrow the error to propagate it further
  }
}

async function add(postData) {
  const res = await api.post(ROLES.ADD, postData);
  return res;
}

async function getItem(code) {
  const res = await api.get(`${ROLES.EDIT}/${code}`);
  return res;
}

async function update(code, postData) {
  const res = await api.patch(`${ROLES.UPDATE}/${code}`, postData);
  return res;
}

async function deleteItem(code) {
  const res = await api.delete(`${ROLES.DELETE}/${code}`);
  return res;
}

async function getActiveItem() {
  const res = await api.get(`${ROLES.ACTIVE}`);
  return res;
}

async function getAllPermissions() {
  const res = await api.get(`${PERMISSIONS.GET_ALL_LIST}`);
  return res;
}

// async function getRoleBasedUser(code) {
//   const res = await api.get(`${ROLES.USER}/user/${code}`);
//   return res;
// }

async function getPermissions(code, type) {
  const res = await api.get(`${PERMISSIONS.GET_ITEM}/${type}/${code}`);
  return res;
}

async function assignPermission(code, type, postData) {
  const res = await api.post(`${PERMISSIONS.ASSIGN}/${type}/${code}`, postData);
  return res;
}

async function getUserPermissions() {
  const res = await api.get(`${PERMISSIONS.CURRENT_USER}`);
  return res;
}

const RolePermService = {
  getAll,
  add,
  update,
  getItem,
  deleteItem,
  getActiveItem,
  getAllPermissions,
  // getRoleBasedUser,
  assignPermission,
  getPermissions,
  getUserPermissions
};

export default RolePermService;
